/**
 * Enables copying HTML by clicking a link
 */
import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/traversal/filter/filter.js";
import "dabbyjs/src/core/each/each.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/attributes/data/data.js";
import "dabbyjs/src/attributes/attr/attr.js";
import "dabbyjs/src/attributes/class/class.js";
import "dabbyjs/src/traversal/children/children.js";
import "dabbyjs/src/manipulation/html/html.js";
import "dabbyjs/src/manipulation/text/text.js";

function absolute(href) {
	const link = document.createElement("a");
	link.href = href;
	return link.protocol + "//" + link.host + link.pathname + link.search + link.hash;
}

export default obj => {
	if (obj.length) {
		obj.filter("[data-copy]").on("click", function (e) {
			const $this = $(this),
				selector = $this.data("copy"),
				copy = $(selector),
				attr = selector.indexOf("[");

			// if there is something to copy
			if (copy.length) {
				let text;

				// read an attribute
				if (attr > -1) {
					const name = selector.split("[")[attr === 0 ? 0 : 1].slice(0, -1);
					text = copy.attr(name);
					if (["href", "src", "action", "poster"].indexOf(name) > -1) {
						text = absolute(text);
					}

				// make urls absolute
				} else if (copy.children().length) {
					$("*", copy).each(function () {
						["href", "src", "action", "poster"].forEach(item => {
							if (this[item]) {
								this[item] = absolute(this[item]);
							}
						});
					});
					text = copy.html();
				} else {
					text = copy.text();
				}

				// copy the text into the clipboard
				navigator.clipboard.writeText(text)
					.then(() => {
						const text = $this.text(),
							cls = $this.get(0).classList[0] + "--copied";
						$this.text("Copied ✔");
						$this.addClass(cls);
						setTimeout(() => {
							$this.text(text);
							$this.removeClass(cls);
						}, 5000);
					})
					.catch(e => {
						$this.text("Error");
						$this.addClass($this.get(0).classList[0] + "--error");
						console.error("Your browser doesn't support this command or you have not granted permissions: " + e.message);
					});
			}
			e.preventDefault();
		});
	}
};
